<div class="audio-preview-wrapper" (click)="playing ? pause() : play()">
  <i i-bs [name]="playing ? 'pause-fill' : 'play-fill'" width="17" height="17"></i>
  <span class="audio-label-text">Fichier audio</span>

  <i *ngIf="canBeRemoved" (click)="remove?.emit()" class="remove-button" i-bs name="x" width="12" height="12"></i>
</div>
